import {
  SandboxTree,
  stickerTypeProperty,
  systemStickers,
  Tag
} from 'yougile-model'
import {logger, Util} from 'yougile-util'

import {Sync} from '../../../client/sync'
import {Sticker} from '../sticker'
import {AStickerCtl} from './a-sticker-ctl'

export abstract class ASystemStickerCtl<T> extends AStickerCtl<T> {
  public override get isSystem(): boolean {
    return true
  }

  protected onInit(_: Tag): void {
    Util.noop()
  }

  public init(box: SandboxTree): void {
    const profile = Sync.getProfile()
    if (profile.companyId === box.companyId) {
      return
    }
    const title = this.type[0].toUpperCase() + this.type.slice(1)
    if (!Sticker.getByName(box, title)) {
      logger.log(
        `Sticker not found: ${title}
        in ${box.get(box.companyId).title}`
      )
    }
  }

  public get title(): string {
    const {type} = this
    return type[0].toUpperCase() + type.slice(1)
  }

  public make(box: SandboxTree): Tag {
    const sticker = new Tag(box.companyId, this.title)
    if (this.title in systemStickers) {
      sticker.id = systemStickers[this.title as keyof typeof systemStickers]
    }
    sticker.properties[stickerTypeProperty] = this.type
    return sticker
  }

  public getSticker(box: SandboxTree): Tag {
    return Sticker.getByName(box, this.title)
  }
}
